<main class="family-relationships-page">
  <mat-card class="family-card">
    <section class="page-context" aria-labelledby="page-title">
      <div class="page-context__title-row">
        <button mat-icon-button type="button" class="back-button" aria-label="Volver a la ficha del miembro" (click)="back()"><mat-icon>arrow_back</mat-icon></button>
        <mat-icon class="page-context__icon" aria-hidden="true">diversity_1</mat-icon>
        <h2 id="page-title">Vínculos familiares</h2>
      </div>
      <p>Registrá los vínculos del miembro.</p>
    </section>

    <div *ngIf="isLoadingRelationships" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <form *ngIf="!isLoadingRelationships" [formGroup]="form" (ngSubmit)="save()" class="relationships-form">
      <div class="relationship-grid">
        <section class="relationship-section" *ngFor="let section of sections">
          <header class="relationship-section__header">
            <div class="relationship-section__title-group">
              <span class="relationship-section__icon" [class]="'relationship-section__icon relationship-section__icon--' + section[0]"><mat-icon>{{ section[2] }}</mat-icon></span>
              <div><h2>{{ section[1] }}</h2><span>{{ rows(section[0]).length }} {{ rows(section[0]).length === 1 ? 'vínculo' : 'vínculos' }}</span></div>
            </div>
            <button mat-stroked-button type="button" class="add-button" (click)="add(section[0])"><mat-icon>add</mat-icon>Agregar</button>
          </header>
          <div class="relationship-section__content" [formArrayName]="section[0]">
            <div class="empty-state" *ngIf="rows(section[0]).length === 0"><mat-icon>person_add</mat-icon><span>No hay {{ section[3] }} registrados.</span></div>
            <div class="relationship-row relationship-row--read" *ngFor="let row of rows(section[0]).controls; let i = index" [formGroupName]="i">
              <app-member-reference [personId]="row.get('relatedPersonId')?.value" [name]="row.get('relatedPersonName')?.value || ''" [isDeceased]="row.get('isRelatedPersonDeceased')?.value"></app-member-reference>
              <button mat-icon-button type="button" class="edit-button" aria-label="Editar vínculo" (click)="edit(section[0], i)"><mat-icon>edit</mat-icon></button>
              <button mat-icon-button type="button" class="delete-button" aria-label="Eliminar vínculo" (click)="remove(section[0], i)"><mat-icon>delete_outline</mat-icon></button>
            </div>
          </div>
        </section>
      </div>
    </form>
  </mat-card>
</main>
